import styles from './section.css';

function Section({children, title}) {
    return (
        <div className="section">
            <div className="section-header">{title}</div>
            <div className="section-content">{children}</div>
        </div>
    )
}

export default Section;